import { IRegistration } from '../../store/registrations/interfaces'
type GenderCheckResult = {
  message?: string
  ok: boolean
}

export const checkProperGender = (
  gender: string,
  registrations: IRegistration[]
): GenderCheckResult => {
  if (!['m', 'w', 'd'].some(option => gender === option)) {
    return {
      ok: false,
      message: 'Bitte wählen Sie eine der gegebenen Optionen aus.',
    }
  }
  for (const reg of registrations) {
    // Existing (backend-loaded) registrations may have been added as a special exception by a
    // backend user; do not check them for gender conformity. Past registrations may also have
    // no event details (hide_past_events).
    if (!reg.event || reg.loadedFromBackend) {
      continue
    }
    //TODO: Should this not ignore family-registration?
    if (!reg.event.allowed_genders.includes(gender)) {
      return {
        ok: false,
        message: `Das ausgewählte Geschlecht ist inkompatibel mit den Voraussetzungen der Veranstaltung ${reg.event.name}!`,
      }
    }
  }
  return {
    ok: true,
  }
}
